/**
 * @generated SignedSource<<671b3416be6079499aebade1543cf49d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type apiIntegrationSalesChannelDialogQuery$variables = {
  salesChannelID?: string | null;
};
export type apiIntegrationSalesChannelDialogQuery$data = {
  readonly currencies: ReadonlyArray<{
    readonly code: string | null;
    readonly id: string;
    readonly name: string | null;
    readonly symbol: string | null;
  } | null> | null;
  readonly ecommerceSettingsForApiIntegration: {
    readonly currencyID: number;
    readonly productsApi: string | null;
    readonly remoteUrl: string | null;
  } | null;
  readonly lcidCurrenciesList: ReadonlyArray<{
    readonly languageCulture: string | null;
  } | null> | null;
};
export type apiIntegrationSalesChannelDialogQuery = {
  response: apiIntegrationSalesChannelDialogQuery$data;
  variables: apiIntegrationSalesChannelDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "salesChannelID"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Currency",
  "kind": "LinkedField",
  "name": "currencies",
  "plural": true,
  "selections": [
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "symbol",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "salesChannelID",
    "variableName": "salesChannelID"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currencyID",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remoteUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productsApi",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "LanguageCurrency",
  "kind": "LinkedField",
  "name": "lcidCurrenciesList",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "languageCulture",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "apiIntegrationSalesChannelDialogQuery",
    "selections": [
      (v2/*:: as any*/),
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "ecommerceSettingsForApiIntegration",
        "plural": false,
        "selections": [
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/)
        ],
        "storageKey": null
      },
      (v7/*:: as any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "apiIntegrationSalesChannelDialogQuery",
    "selections": [
      (v2/*:: as any*/),
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": "EcommerceSettings",
        "kind": "LinkedField",
        "name": "ecommerceSettingsForApiIntegration",
        "plural": false,
        "selections": [
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v1/*:: as any*/)
        ],
        "storageKey": null
      },
      (v7/*:: as any*/)
    ]
  },
  "params": {
    "cacheID": "bcea270761c37f9238e838aafffb9ddb",
    "id": null,
    "metadata": {},
    "name": "apiIntegrationSalesChannelDialogQuery",
    "operationKind": "query",
    "text": "query apiIntegrationSalesChannelDialogQuery(\n  $salesChannelID: ID\n) {\n  currencies {\n    id\n    code\n    name\n    symbol\n  }\n  ecommerceSettingsForApiIntegration(salesChannelID: $salesChannelID) {\n    currencyID\n    remoteUrl\n    productsApi\n    id\n  }\n  lcidCurrenciesList {\n    languageCulture\n  }\n}\n"
  }
};
})();

(node as any).hash = "30f2f4b6a1fd2a0308ac1211c443c4a5";

export default node;
